import axios from 'axios'

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_PATH}`,
  timeout: 300000,
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/pms/login'
    }
    return Promise.reject(error)
  }
)

export default api